import React, { useEffect } from 'react'
import FAQSection from '../FAQSection/FAQSection';
import benefitIcno1 from '../PersonalLoan/images/benefiticon1.webp';
import benefitIcno2 from '../PersonalLoan/images/benefiticon2.webp';
import benefitIcno3 from '../PersonalLoan/images/benefiticon3.webp';
import benefitIcno4 from '../PersonalLoan/images/benefiticon4.webp';
import EligibilityCriteria from '../PersonalLoan/images/eligibility-criteria.webp';
import greenticknew from '../../Icons/greenticknew.svg';
import "../footermorelinkspages.css";
import RightSidePopUp from '../Right Side PopUp/RightSidePopUp';
import NewLoginForm from '../Journey Form/Form/NewLoginForm';
import StepSlider from '../HowToApplyPLSLIDER/StepSlider';
import { useSelector, useDispatch } from 'react-redux';
import CKYCWaiting from '../LoginPopUp/CKYCWaiting';
import NewLeftPart from '../Journey Form/FormLeftPart/NewLeftPart';
import MobileFooter from '../Footer/MobileFooter';
import FeaturesBenefits from '../PersonalLoan/FeaturesBenefits'
import { updateProductId } from '../../Redux/action';
import HittingMetaTagApi from '../Instant Personal Loan/HittingMetaTagApi';
import FAQSectionChk from '../FAQ/FAQ';
import { Helmet } from 'react-helmet';
import EligibilityCriteriaSection from '../PersonalLoan/EligibilityCriteria';

const PLonAdhaar = () => {
    const { PLLoader, formStates, mwpages } = useSelector(state => state)
    var loan_type_id_page = 56;
    const [data, setData] = React.useState({ sub_bread: " Peronsal Loan On Aadhar Card" })
    const dispatch = useDispatch()
    const [y, sety] = React.useState(true);
    window.addEventListener("scroll", (event) => {
        if (window.scrollY <= 200 || window.scrollY >= 2638) {
            sety(false);
        }
        else {
            sety(true);
        }
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(updateProductId(loan_type_id_page))
    }, [])


    const dataa = {
        heading: [
            {
                left: "Eligibility Criteria for",
                right: "Aadhar Card Loan"
            }
        ],
        subhead: [
            {
                head: "Age",
                content: "A candidate must be aged between 21 to 55 years."
            },
            {
                head: "Net Monthly Income",
                content: "INR 20,000 & above."
            },
            {
                head: "Credit score",
                content: "Minimum credit score requirement is 650."
            },
            {
                head: "Total Work Experience",
                content: "Minimum 2 years."
            }
        ]
    }
    const datafandb= {
        givendata:[
        {
        span:"Simplified",
        para:"Application Process",
    },
    {
        span:"No collateral required",
        para:"to apply for a loan",
    },
    {
        span:"Competitive interest rates",
        para:"based on your eligibility",
    },
    {
        span:"Part payment and",
        para:"foreclosure facility",
    },
    {
        span:"Multipurpose ",
        para:"Usage",
    },
    {
        span:"Flexible",
        para:"Repayment Options",
    }
    ]
    }

    return (
        <>
            <Helmet>
                <title>{mwpages?.metatagsdata?.page_title ? mwpages.metatagsdata.page_title : ""}</title>
                <meta name="description" content={mwpages?.metatagsdata?.page_description ? mwpages.metatagsdata?.page_description : ""} />
                <meta name="keywords" content={mwpages?.metatagsdata?.page_keywords ? mwpages.metatagsdata.page_keywords : ""} />
            </Helmet>
            <HittingMetaTagApi />
            <div className='journey-stop'>
                {y && <RightSidePopUp />}
                <NewLoginForm pageType={loan_type_id_page} mapData={data} />
                <div >
                    <section className="what-is newpl-main  manage-top-margin-main web-margin-top">
                        <div className="ploan-container">
                            <div className="re-sh-box ploan-content1 ">
                                <h4 className="heading-h2" style={{ marginBottom: "18px" }}>How to Get Instant Personal Loan on <b>Aadhaar Card</b>?</h4>
                                <p className="heading-p">A  <a className='marriage-loan-a' href='/personal-loan'>personal loan</a>  on Aadhar Card is an unsecured credit provided by lending institutions to handle unforeseen situations that demand instant financial assistance. At MoneyWide, you can get a quick aadhaar-based personal loan of upto INR 3 lacs at affordable rates with multiple facilities that facilitate instant access to funds in times of need.</p>
                                <p className="heading-p">An aadhar card is a 12-digit distinct number that stores your biometric data and is used as an individual's address, ID, and age proof. Instead of carrying out a document-intensive process to validate your identity, lenders use an aadhar card as a single KYC document which expedites the verification process and results in quick approval on loan applications.</p>
                            </div>
                        </div>
                    </section>

                     <EligibilityCriteriaSection elgdata={dataa} />
                    <FeaturesBenefits features={datafandb}/>
                    <StepSlider />
                    {/* <section className="FAQs">
                        <FAQSection />
                    </section> */}
                    {mwpages.faqdata.length !== 0 ? <section style={{ margin: "50px 0" }}>
                        <FAQSectionChk data={mwpages.faqdata} />
                    </section> : ""}
                </div>
            </div>
            <div className='journey-start' style={{ display: "none" }}>
                {PLLoader.show && <CKYCWaiting heading={"We are redirecting."} />}
                <NewLeftPart title="Get Instant Loan Using MoneyWide" content="Moneywide is a digital lending app which provides you instant loans through a completely paperless process." />
                {(!formStates.IsIframe) && <MobileFooter />}
            </div>
        </>
    )
}

export default PLonAdhaar;